import apollo from 'graphql/apollo';
import { forgotPasswordMutation } from 'graphql/mutations';

const forgotPassword = async ({ email, otp }) =>
  apollo.mutate({
    mutation: forgotPasswordMutation,
    variables: { email, otp },
  });
export default forgotPassword;
